<template>
  <PaginateTable :items="problems" v-slot="{ paginatedItems }">
    <div v-if="paginatedItems.length > 0" class="table-container">
    <table class="table table-sm">
      <thead class="table-light">
        <tr>
          <th scope="col" class="col-host">Host</th>
          <th scope="col" class="col-problema">Problema</th>
          <th scope="col" class="col-horario">Horário</th>
          <th scope="col" class="col-acknowledge"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="problem in paginatedItems" :class="{'modal-opened-row': otherModalOpened(problem.eventid)}" :key="problem.eventid">
            <td 
              style="vertical-align: middle;" 
              class="copyable-field col-host"
              @click="copyToClipboard(problem.hostName, 'Host')"
              :title="`Clique para copiar: ${problem.hostName}`"
            >
              {{ problem.hostName }}
            </td>
            <td 
              style="vertical-align: middle;" 
              class="copyable-field"
              @click="copyToClipboard(problem.name, 'Problema')"
              :title="`Clique para copiar: ${problem.name}`"
            >
              {{ problem.name }}
            </td>
            <td 
              style="vertical-align: middle;" 
              class="copyable-field"
              @click="copyToClipboard(problem.readableTime, 'Horário')"
              :title="`Clique para copiar: ${problem.readableTime}`"
            >
              {{ problem.readableTime }}
            </td>
            <td class="text-center" style="vertical-align: middle;">
                <div v-if="!otherModalOpened(problem.eventid)" class="d-flex gap-2 justify-content-center action-buttons">
                  <button
                    type="button"
                    class="whatsapp-btn"
                    @click="sendWhatsapp(problem)"
                    :disabled="!problem.phoneNumber || whatsappMessageSent(problem.eventid)"
                    :title="problem.phoneNumber ? 'Enviar WhatsApp' : 'Número não disponível'"
                  >
                  <img class="icon-message" src="/whatsapp.png" alt="whatsapp" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-secondary btn-sm rounded-circle fs-4"
                    @click="openTicketModal(problem)"
                    title="Abrir Ticket"
                  >
                    <Icon icon="mdi:ticket-confirmation" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger btn-sm rounded-circle fs-5"
                    @click="openAckModal(problem)"
                    title="Acknowledged"
                  >
                    <img class="icon-message btn-sm rounded-circle" src="/zabbix.webp" alt="zabbix" />
                  </button>
                </div>
                <template v-else>
                <div
                
                class="opened-modal-user"
                >
                {{ otherModalOpened(problem.eventid)?.user?.name }}
                </div>
                </template>
            </td>
        </tr>
      </tbody>
    </table>
    </div>
  </PaginateTable>
  
  <ModalContent 
    :is-modal-open="isTicketModalOpen"
    @close="closeTicketModal"
    @send="sendTicket"
    title="Abrir Ticket"
    :is-loading="isLoadingTicket"
  >
    <div class="edited-messages">
      <div class="d-flex align-items-center gap-3">
        <img class="icon-message logo-metro" src="/logo-1-ok.png" alt="ticket" />
      </div>
      <br>
      <div class="form-floating">
        <textarea 
          class="form-control edited-message" 
          placeholder="Digite o título do ticket" 
          id="ticketTitleArea"
          v-model="editedTemplate.ticketTitle"
        ></textarea>
        <label for="ticketTitleArea">Título</label>
      </div>
      <div v-if="editedTemplate.ticketTitle.length < 5" class="text-danger">Escreva um título maior</div>
      
      <div v-if="messageComponent && isMonitoring">
        <br>
        <div class="d-flex align-items-center gap-3">
          <Icon class="icon" icon="mdi-office-building" />
          <label class="form-label">Ticket na empresa</label>
        </div>
        <br>
        <component
          :is="messageComponent"
          v-model:company="dataMessageComponent"
          @update:company="updateCompany"
        />
      </div>
    </div>
  </ModalContent>

  <ModalContent 
    :is-modal-open="isAckModalOpen"
    @close="closeAckModal"
    @send="sendAck"
    title="Acknowledged"
    :is-loading="isLoadingAck"
    :hide-send="editedTemplate.acknowledged.length < 10"
  >
    <div class="edited-messages">
      <div class="d-flex align-items-center gap-3">
        <img class="icon-message" src="/zabbix.webp" alt="zabbix" />
        <label class="form-label">Mensagem de Acknowledged</label>
      </div>
      <br>
      <div class="form-floating">
        <textarea 
          class="form-control edited-message" 
          placeholder="Digite a mensagem de acknowledged" 
          id="ackMessageArea"
          v-model="editedTemplate.acknowledged"
        ></textarea>
        <label for="ackMessageArea">Mensagem de envio</label>
      </div>
      <div v-if="editedTemplate.acknowledged.length < 10" class="text-danger">Escreva uma mensagem maior</div>
    </div>
  </ModalContent>
</template>

<script>
import { companyTemplateMap, templates, ticketMessage } from '@/configs/templates';
import  PaginateTable from '@/components/PaginateTable.vue';
import { logService } from '@/services/backend/ApiService';
import { toast } from 'vue3-toastify';
import { Icon } from '@iconify/vue';
import OnlineUserService from '@/services/OnlineUserService';
import { sendWhatsappMessage } from '@/services/backend/ApiService';
import { ZabbixActions } from '@/services/backend/zabbixActions';
import ModalContent from '@/components/ModalContent.vue';
import { hide } from '@popperjs/core';

export default {
  components: {
    PaginateTable,
    Icon,
    ModalContent
  },
  emits: ['open-modal', 'close-modal'],
  props: {
    problems: {
      type: Object,
      required: true,
    },
    modalsOpened: {
      type: Array,
      required: false,
      default: () => []
    },
    whatsappSentProblems: {
      type: Array,
      required: false,
      default: () => []
    },
    title: {
      type: String,
      required: true
    },
    openTicketType: {
      type: Number,
      required: true
    },
    companyId:{
      type: Number,
      required: true
    },
    error: {
      type: Boolean,
      default: false
    },
    lastUpdate: {
      type: Number,
      required: true
    },
    isMonitoring: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      zabbixInstances: [],
      zabbixComandsInstance: null,
      selectedProblem: null,
      intervalId: null,
      currentPage: 1,
      whatsappChecked: true,
      ticketChecked: true,
      acknowledgedChecked: true,
      isTicketModalOpen: false,
      isAckModalOpen: false,
      selectedZabbixInstance: null,
      messageComponent: companyTemplateMap[this.companyId]?.component,
      dataMessageComponent: companyTemplateMap[this.companyId]?.template,
      editedTemplate: templates[0],
      isLoadingTicket: false,
      isLoadingAck: false
    };
  },
  computed: {
    companyComponent() {
      const companyMap = companyTemplateMap[this.companyId];
      return companyMap && companyMap.component ? companyMap.component : null;
    }
  },
  beforeUnmount() {
    if (this.isTicketModalOpen) {
      this.closeTicketModal();
    }
    if (this.isAckModalOpen) {
      this.closeAckModal();
    }
  },
  methods: {
    openTicketModal(problem) {
      this.selectedProblem = problem;
      this.isTicketModalOpen = true;

      this.$emit('open-modal', {
        company: { 
          id: this.companyId
        },
        eventId: this.selectedProblem.eventid,
      });
    },
    closeTicketModal() {
      this.isTicketModalOpen = false;
      this.selectedZabbixInstance = null;
      this.$emit('close-modal', {
        company: {
          id: this.companyId
        },
        eventId: this.selectedProblem?.eventid
      });

      this.selectedProblem = null;
    },
    openAckModal(problem) {
      this.selectedProblem = problem;
      this.isAckModalOpen = true;

      this.$emit('open-modal', {
        company: { 
          id: this.companyId
        },
        eventId: this.selectedProblem.eventid,
      });
    },
    closeAckModal() {
      this.isAckModalOpen = false;
      this.selectedZabbixInstance = null;
      this.$emit('close-modal', {
        company: {
          id: this.companyId
        },
        eventId: this.selectedProblem?.eventid
      });

      this.selectedProblem = null;
    },
    async sendWhatsapp(problem) {
      if (!problem.phoneNumber) {
        toast.error('Número de telefone não disponível para este problema');
        return;
      }

      try {
        const user = OnlineUserService.getUser();
        const whatsappMessage = `*${user.name}* \n ⚠️ Novo Incidente Identificado  \n\n 💻 Equipamento: ${problem.hostName}\n 🚨 Problema: ${problem.name}\n ⏱️ Horário: ${problem.readableTime}`;

        await sendWhatsappMessage(
          whatsappMessage,
          problem.phoneNumber,
          problem.eventid,
          problem.zabbixId || this.companyId
        );

        toast.success('Mensagem WhatsApp enviada com sucesso!');
        
        logService.create({
          company: {
            id: this.companyId
          },
          value: {
            phoneNumber: problem.phoneNumber,
            problemName: problem.name,
            hostName: problem.hostName
          },
          type: "WhatsApp Enviado"
        });

      } catch (error) {
        console.error('Erro ao enviar WhatsApp:', error);
        toast.error('Erro ao enviar mensagem via WhatsApp');
      }
    },
    async sendTicket() {
      if (this.isLoadingTicket) return;
      // Validação antes de enviar
      if (this.editedTemplate.ticketTitle.length < 5) {
        toast.error('O título do ticket deve ter pelo menos 5 caracteres');
        return;
      }

      const options = {
        whatsapp: false,
        ticket: true,
        acknowledged: false,
        ackMessage: '',
        ticketTitle: this.editedTemplate.ticketTitle,
        ticketType: this.openTicketType,
        ticketMessage: ticketMessage,
        ticketCompanyData: this.dataMessageComponent,
        companyId: this.companyId,
        isMonitoring: this.isMonitoring
      };

      logService.create({
        company: {
          id: this.companyId
        },
        value: {
          ticket: true,
          acknowledged: false,
        },
        type: "Ticket Criado"
      });
      
      try {
        this.isLoadingTicket = true;
        
        await ZabbixActions.execute(options, this.selectedProblem);

        this.isLoadingTicket = false;
        this.closeTicketModal();
        toast.success('Ticket criado com sucesso!');
      } catch (error) {
        this.isLoadingTicket = false;
        toast.error("Erro ao criar ticket");
        console.log("Erro ao criar ticket", error);
      }
    },
    async sendAck() {
      if (this.isLoadingAck) return;
      // Validação antes de enviar
      if (this.editedTemplate.acknowledged.length < 10) {
        toast.error('A mensagem de acknowledged deve ter pelo menos 10 caracteres');
        return;
      }

      const options = {
        whatsapp: false,
        ticket: false,
        acknowledged: true,
        ackMessage: this.editedTemplate.acknowledged,
        ticketTitle: '',
        ticketType: this.openTicketType,
        ticketMessage: ticketMessage,
        ticketCompanyData: this.dataMessageComponent,
        companyId: this.companyId,
        isMonitoring: this.isMonitoring
      };

      logService.create({
        company: {
          id: this.companyId
        },
        value: {
          ticket: false,
          acknowledged: true,
        },
        type: "Acknowledged Enviado"
      });
      
      try {
        this.isLoadingAck = true;
        
        await ZabbixActions.execute(options, this.selectedProblem);

        this.isLoadingAck = false;
        this.closeAckModal();
        toast.success('Acknowledged enviado com sucesso!');
      } catch (error) {
        this.isLoadingAck = false;
        toast.error("Erro ao enviar acknowledged");
        console.log("Erro ao enviar acknowledged", error);
      }
    },
    async copyToClipboard(text, fieldName) {
      try {
        await navigator.clipboard.writeText(text);
        toast.info(`Copiado`, {
          autoClose: 2000,
        });
      } catch (error) {
        this.fallbackCopyTextToClipboard(text, fieldName);
      }
    },
    fallbackCopyTextToClipboard(text, fieldName) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";
      
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          toast.success(`${fieldName} copiado: ${text}`, {
            autoClose: 2000,
          });
        } else {
          toast.error('Erro ao copiar texto');
        }
      } catch (err) {
        console.error('Fallback: Erro ao copiar', err);
        toast.error('Erro ao copiar texto');
      }
      
      document.body.removeChild(textArea);
    },
    otherModalOpened(eventid) {
      try{
        return this.modalsOpened && this.modalsOpened.find(modal => modal.eventId === eventid);
      } catch (error) {
        return false;
      }
    },
    whatsappMessageSent(eventid) {
      try{
        return this.whatsappSentProblems && this.whatsappSentProblems.find(modal => modal.eventId === eventid);
      } catch (error) {
        return false;
      }
    }
  },
};
</script>

<style scoped>
.icon-message {
  width: 30px;
  height: 30px;
}

.table-container {
  max-width: 1200px;
}

.table-sm {
  table-layout: fixed;
  font-size: 14px;
}
 
.table th,
.table td {
  background-color: transparent;
  text-align: left;
  padding: 10px;
}

.col-id {
  width: 100px;
}

.col-horario {
  width: min(200px, 20vw);
}

.col-host{
  width: min(250px, 20vw);

  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}

.col-acknowledge {
  width: 120px;
}

.col-whatsapp {
  width: 80px;
}

.whatsapp-btn{
  all: unset;
  cursor: pointer;
}

.whatsapp-btn:disabled {
  border: none;
  cursor:unset;
  filter: grayscale(1);
}

.opened-modal-user {
  background: rgb(110 117 205);
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  border-radius: 30px;
  padding: 2px 10px;
}

.title {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  background: #0d6efd;
  color: white;
  height: 45px;
  text-transform: uppercase;
  margin-bottom: 1em;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.pagination .page-link {
  margin: 0 5px;
  cursor: pointer;
}

.page-link.disabled {
  pointer-events: none;
  opacity: 0.6;
}

.edited-message {
  height: 80px !important;
}

.logo-metro {
  width: 200px;
  margin: -15px 0;
  height: fit-content;
}

.modal-opened-row {
  background-color: #cfdaeb !important;
}

.copyable-field {
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-radius: 4px;
  padding: 8px !important;
}

.copyable-field:hover {
  background-color: #e8f4f8 !important;
  color: #0056b3;
}

.copyable-field:active {
  background-color: #d1ecf1 !important;
  transform: scale(0.98);
}

.update-time{
  font-size: 0.8em;
  padding: 2px 10px;
  background-color: #e0e0e0;
  border-radius: 12px;
}

.action-buttons {
  min-width: 80px;
}

.action-buttons .btn {
  font-size: 1rem;
  padding: 0.375rem 0.5rem;
  min-width: 35px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>